import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { constants } from '@ferrero/comon';
import Typography from '@material-ui/core/Typography';
import './styles.scss';

const StatusRow = ({ status, onClick, selected }) => (
  <div
    className="calendar-userList-item"
    role="button"
    tabIndex={ 0 }
    onClick={ () => onClick(status) }
  >
    <div
      className="calendar-userList-color"
      style={ {
        backgroundColor: selected ? status.color : 'white',
        borderColor: status.color,
      } }
    />
    { `${status.label}` }
  </div>
);

StatusRow.propTypes = {
  status: PropTypes.object,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

/**
 * React HolidayStatusSelect component 
 * @param {function} onChange callback to call when event status changes 
 * @returns {render} HolidayStatusSelect react component
 */
function HolidayStatusSelect({ onChange }) {
  const data = Object.entries(constants.HOLIDAY_STATUS)
    .map(([key, value]) => ({ ...value, id: parseInt(key, 10) }))
    .filter((s) => s.id);

  const [selected, setSelecetd] = useState(data.map((s) => s.id));
  const handleClick = (s) => {
    const newValue = selected.find((i) => i === s.id) !== undefined
      ? selected.filter((i) => i !== s.id)
      : [...selected, s.id];

    setSelecetd(newValue);
    onChange(newValue);
  };

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Congés
      </Typography>
      <div className="calendar-userList-container">
        { data.map((s) => (
          <StatusRow
            key={ s.id }
            status={ s }
            onClick={ handleClick }
            selected={ selected.find((i) => i === s.id) !== undefined }
          />
        )) }
      </div>
    </>
  );
}

HolidayStatusSelect.propTypes = {
  onChange: PropTypes.func,
};

export default HolidayStatusSelect;
